import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';
import { SystemConfig } from '../shared/config/system-config';

@Component({
  selector: 'vit-numbers-grid',
  templateUrl: './numbers-grid.component.html',
  styleUrls: ['./numbers-grid.component.scss']
})
export class NumbersGridComponent implements OnInit {

  @Input() selectedNumbers: number[] = [];
  @Input() showDrawnNumbers: boolean = false;
  @Input() disableTapHighlight: boolean = false;
  @Input() allowWinAnimation: boolean = false;
  @Output() numberClicked: EventEmitter<number> = new EventEmitter();

  numbers: number[] = [];

  constructor(public sessionService: SessionService) {
  }

  ngOnInit() {
    for (let n: number = 1; n <= SystemConfig.Constants.AMOUNT_OF_KENO_NUMBERS; n++) {
      this.numbers.push(n);
    }
  }

  isDrawn(n: number): boolean {
    return this.sessionService.numbers.indexOf(n) > -1;
  }

  isSelected(n: number): boolean {
    return this.selectedNumbers.indexOf(n) > -1;
  }

}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/numbers-grid/numbers-grid.component.ts